<script setup>
// @ts-check
/**
 * @import { Ref } from 'vue'
 */
import { ref } from 'vue'
import { route } from '@/utils/ziggy.js'
// import { postRequest } from '@/utils/fetch'
import ConfirmMoveTalentAnalyticsModal from '@/studentsite/common/components/Modal/ConfirmMoveTalentAnalyticsModal.vue'

// const isDisableExam =
//   /** @type {HTMLInputElement} */ (document.getElementById('_h_is_disable_exam_by_term'))?.value ?? ''

const isNoTAExam = /** @type {HTMLInputElement} */ (document.getElementById('_h_is_no_exam'))?.value ?? ''
// const taExamExecUrl = /** @type {HTMLInputElement} */ (document.getElementById('_h_ta_exam_exec_url'))?.value ?? ''
const isDisableMobileFooter =
  /** @type {HTMLInputElement} */ (document.getElementById('_h_is_disable_mobile_footer'))?.value ?? ''
const taErrorNo = /** @type {HTMLInputElement} */ (document.getElementById('_h_ta_error_no'))?.value ?? ''

const isDisplayConfirmMoveTalentAnalyticsModal = ref(false)

const closeConfirmMoveTalentAnalyticsModal = () => (isDisplayConfirmMoveTalentAnalyticsModal.value = false)

/**
 *
 */
// const transitionTa = async () => {
//   const data = await postRequest('student_api_ta_tainfo_updateexec', taExamExecUrl, {}, { withCsrf: true })
//   if (data.data?.is_disable) {
//     location.href = taResultUrl
//   } else if (data.data?.url.length) {
//     location.href = data.data.url
//   } else {
//     isShowTaError.value = true
//   }
// }

const transition = async () => {
  // @click="isDisplayConfirmMoveTalentAnalyticsModal = true"
  if (parseInt(isNoTAExam) > 0) {
    isDisplayConfirmMoveTalentAnalyticsModal.value = true
  }
  // else if (isDisableExam) {
  //   location.href = taResultUrl
  // }
  else {
    location.href = taResultUrl
  }
}

/** @type {Ref<boolean>} */
const isShowTaError = ref(taErrorNo == '500')

/**
 * @type {Ref<boolean>}
 */
const isShowMenu = ref(false)
/** */
const openMenu = () => {
  isShowMenu.value = true
}
/** */
const closeMenu = () => {
  isShowMenu.value = false
}

const isScoutPage = /** @type {HTMLInputElement} */ (document.getElementById('_h_is_scout'))?.value ?? ''
const isCompanyPage = /** @type {HTMLInputElement} */ (document.getElementById('_h_is_company'))?.value ?? ''
const isMessagePage = /** @type {HTMLInputElement} */ (document.getElementById('_h_is_message'))?.value ?? ''
const isProfilePage = /** @type {HTMLInputElement} */ (document.getElementById('_h_is_profile'))?.value ?? ''

const scoutUrl = /** @type {HTMLInputElement} */ (document.getElementById('_h_scout_url'))?.value ?? ''
const companyListUrl = /** @type {HTMLInputElement} */ (document.getElementById('_h_company_list_url'))?.value ?? ''
const messageUrl = /** @type {HTMLInputElement} */ (document.getElementById('_h_message_url'))?.value ?? ''
const profileUrl = /** @type {HTMLInputElement} */ (document.getElementById('_h_profile_url'))?.value ?? ''
const profileDiagnosisUrl =
  /** @type {HTMLInputElement} */ (document.getElementById('_h_profile_diagnosis_url'))?.value ?? ''
const taResultUrl = /** @type {HTMLInputElement} */ (document.getElementById('_h_ta_result_url'))?.value ?? ''
const settingUrl = /** @type {HTMLInputElement} */ (document.getElementById('_h_setting_url'))?.value ?? ''
const contactUrl = /** @type {HTMLInputElement} */ (document.getElementById('_h_contact_url'))?.value ?? ''

const scoutCount = /** @type {HTMLInputElement} */ (document.getElementById('_h_scout_count'))?.value ?? ''
const messageCount = /** @type {HTMLInputElement} */ (document.getElementById('_h_message_count'))?.value ?? ''
const studentFullName = /** @type {HTMLInputElement} */ (document.getElementById('_h_student_full_name'))?.value ?? ''
const studentLogoImage = /** @type {HTMLInputElement} */ (document.getElementById('_h_student_logo_image'))?.value ?? ''
const studentId = /** @type {HTMLInputElement} */ (document.getElementById('_h_student_id'))?.value ?? ''
const profileFilledRate =
  /** @type {HTMLInputElement} */ (document.getElementById('_h_profile_filled_rate'))?.value ?? ''
</script>

<template>
  <Teleport to="body">
    <div
      class="md_modal md_modal--small modal_TAerror"
      v-if="isShowTaError"
    >
      <button
        class="bgLayer js_modalX"
        @click="isShowTaError = false"
      ></button>
      <div class="modalSet">
        <div class="Content">
          <div class="titleArea">
            <div class="title">
              通信に失敗しました
              <span
                class="closeLink js_modalX"
                @click="isShowTaError = false"
              ></span>
            </div>
            <div class="copy">時間をおいて再度お試しください。</div>
          </div>
          <div class="actionArea">
            <div class="btnSet">
              <button
                class="md_btn md_btn--line js_modalX"
                @click="isShowTaError = false"
              >
                閉じる
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
  <header
    class="md_header"
    id="md_header"
  >
    <div class="logo">
      <a :href="scoutUrl"
        ><img
          :src="`/student_site/imageFile/logo_white.svg`"
          alt=""
      /></a>
    </div>
    <nav
      id="pcNavMenu"
      class="pcShow"
    >
      <ul class="menuList">
        <li
          class="menu menu--scout"
          :class="{ active: isScoutPage == '1' }"
        >
          <a
            :href="scoutUrl"
            class="btn"
          >
            <span class="iconSet">
              <span class="iconImgPart inactive"
                ><svg
                  width="22"
                  height="16"
                  viewBox="0 0 22 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.3333 0H2C0.895333 0.000666667 0.000666667 0.896 0 2V14C0.00133333 15.1047 0.896 15.9993 2 16H19.3327C20.4373 15.9987 21.332 15.104 21.3327 14V2C21.3313 0.896 20.4373 0.00133333 19.3333 0ZM19.3333 1.33333C19.4253 1.33333 19.5133 1.35267 19.5933 1.38667L19.5893 1.38533L10.6667 9.12L1.74467 1.38533C1.82 1.35267 1.908 1.334 2 1.334L19.3333 1.33333ZM19.3333 14.6667H2C1.63133 14.6667 1.33267 14.368 1.33267 13.9993V2.794L10.2293 10.5047C10.346 10.606 10.4993 10.668 10.6673 10.668C10.8353 10.668 10.9887 10.606 11.106 10.504L11.1053 10.5047L20.002 2.794V13.9993C20.002 14.368 19.7033 14.6667 19.3347 14.6667H19.3333Z"
                    fill="#fff"
                  ></path>
                </svg>
              </span>
              <span class="iconImgPart active"
                ><svg
                  width="22"
                  height="16"
                  viewBox="0 0 22 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0 14C0.00133333 15.1047 0.896 15.9993 2 16H19.3327C20.4373 15.9987 21.332 15.104 21.3327 14V2C21.3326 1.93853 21.3298 1.87771 21.3243 1.81765L10.6567 11.2699L0.0307661 1.64974C0.0106166 1.76347 7.2154e-05 1.88051 0 2V14ZM10.6693 8.91363L20.3884 0.301791C20.1961 0.181893 19.9819 0.0937307 19.7532 0.044626C19.6178 0.0155557 19.4774 0.000173966 19.3333 0H2C1.81157 0.000113719 1.62925 0.0262596 1.45643 0.0750328C1.32293 0.112709 1.19511 0.163887 1.07452 0.226998L10.6693 8.91363Z"
                    fill="#fff"
                  ></path>
                </svg>
              </span>
            </span>
            スカウト
            <span
              class="md_numBadge"
              v-if="scoutCount.length > 0 && scoutCount != '0'"
              >{{ scoutCount }}</span
            >
          </a>
        </li>
        <li
          class="menu menu--companyList"
          :class="{ active: isCompanyPage == '1' }"
        >
          <a
            :href="companyListUrl"
            class="btn"
          >
            <span class="iconSet">
              <span class="iconImgPart inactive"
                ><svg
                  width="19"
                  height="20"
                  viewBox="0 0 19 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0.399902 1.00039C0.399902 0.66902 0.668532 0.400391 0.999902 0.400391H17.7553C18.0867 0.400391 18.3553 0.66902 18.3553 1.00039V19.0004C18.3553 19.3318 18.0867 19.6004 17.7553 19.6004H12.4154C12.084 19.6004 11.8154 19.3318 11.8154 19.0004V15.554H6.93979V19.0004C6.93979 19.3318 6.67116 19.6004 6.33979 19.6004H0.999902C0.668532 19.6004 0.399902 19.3318 0.399902 19.0004V1.00039ZM1.5999 1.60039V18.4004H5.73979V14.954C5.73979 14.6226 6.00842 14.354 6.33979 14.354H12.4154C12.7468 14.354 13.0154 14.6226 13.0154 14.954V18.4004H17.1553V1.60039H1.5999ZM5.01172 5.70547C5.01172 5.3741 5.28035 5.10547 5.61172 5.10547H7.6167C7.94807 5.10547 8.2167 5.3741 8.2167 5.70547C8.2167 6.03684 7.94807 6.30547 7.6167 6.30547H5.61172C5.28035 6.30547 5.01172 6.03684 5.01172 5.70547ZM11.141 5.10547C10.8096 5.10547 10.541 5.3741 10.541 5.70547C10.541 6.03684 10.8096 6.30547 11.141 6.30547H13.145C13.4764 6.30547 13.745 6.03684 13.745 5.70547C13.745 5.3741 13.4764 5.10547 13.145 5.10547H11.141ZM5.01172 10.0219C5.01172 9.6905 5.28035 9.42188 5.61172 9.42188H7.6167C7.94807 9.42188 8.2167 9.6905 8.2167 10.0219C8.2167 10.3532 7.94807 10.6219 7.6167 10.6219H5.61172C5.28035 10.6219 5.01172 10.3532 5.01172 10.0219ZM11.141 9.42188C10.8096 9.42188 10.541 9.6905 10.541 10.0219C10.541 10.3532 10.8096 10.6219 11.141 10.6219H13.145C13.4764 10.6219 13.745 10.3532 13.745 10.0219C13.745 9.6905 13.4764 9.42188 13.145 9.42188H11.141Z"
                    fill="#fff"
                  ></path>
                </svg>
              </span>
              <span class="iconImgPart active"
                ><svg
                  width="19"
                  height="20"
                  viewBox="0 0 19 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M1 0.25C0.585786 0.25 0.25 0.585786 0.25 1V19C0.25 19.4142 0.585786 19.75 1 19.75H6.33988C6.7541 19.75 7.08988 19.4142 7.08988 19V15.7036H11.6655V19C11.6655 19.4142 12.0013 19.75 12.4155 19.75H17.7554C18.1696 19.75 18.5054 19.4142 18.5054 19V1C18.5054 0.585786 18.1696 0.25 17.7554 0.25H1ZM4.91182 5.70508C4.91182 5.31848 5.22522 5.00508 5.61182 5.00508H7.6168C8.0034 5.00508 8.3168 5.31848 8.3168 5.70508C8.3168 6.09168 8.0034 6.40508 7.6168 6.40508H5.61182C5.22522 6.40508 4.91182 6.09168 4.91182 5.70508ZM10.4411 5.70505C10.4411 5.31845 10.7545 5.00505 11.1411 5.00505H13.1451C13.5317 5.00505 13.8451 5.31845 13.8451 5.70505C13.8451 6.09165 13.5317 6.40505 13.1451 6.40505H11.1411C10.7545 6.40505 10.4411 6.09165 10.4411 5.70505ZM4.91184 10.0213C4.91184 9.63474 5.22524 9.32134 5.61184 9.32134H7.61683C8.00343 9.32134 8.31683 9.63474 8.31683 10.0213C8.31683 10.4079 8.00343 10.7213 7.61683 10.7213H5.61184C5.22524 10.7213 4.91184 10.4079 4.91184 10.0213ZM10.4411 10.0213C10.4411 9.63474 10.7545 9.32134 11.1411 9.32134H13.1451C13.5317 9.32134 13.8451 9.63474 13.8451 10.0213C13.8451 10.4079 13.5317 10.7213 13.1451 10.7213H11.1411C10.7545 10.7213 10.4411 10.4079 10.4411 10.0213Z"
                    fill="#fff"
                  ></path>
                </svg>
              </span>
            </span>
            企業リスト
          </a>
        </li>
        <li
          class="menu menu--message"
          :class="{ active: isMessagePage == '1' }"
        >
          <a
            :href="messageUrl"
            class="btn"
          >
            <span class="iconSet">
              <span class="iconImgPart inactive"
                ><svg
                  width="22"
                  height="20"
                  viewBox="0 0 22 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0.399902 1.00039C0.399902 0.66902 0.668532 0.400391 0.999902 0.400391H20.9999C21.3313 0.400391 21.5999 0.66902 21.5999 1.00039V13.9604C21.5999 14.2918 21.3313 14.5604 20.9999 14.5604H11.2267L5.6825 19.4504C5.50562 19.6064 5.25374 19.6443 5.03877 19.5473C4.8238 19.4502 4.68562 19.2362 4.68562 19.0004V14.5604H0.999902C0.668532 14.5604 0.399902 14.2918 0.399902 13.9604V1.00039ZM1.5999 1.60039V13.3604H5.28562C5.61699 13.3604 5.88562 13.629 5.88562 13.9604V17.6712L10.603 13.5104C10.7126 13.4137 10.8538 13.3604 10.9999 13.3604H20.3999V1.60039H1.5999Z"
                    fill="#fff"
                  ></path>
                </svg>
              </span>
              <span class="iconImgPart active"
                ><svg
                  width="22"
                  height="20"
                  viewBox="0 0 22 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M1 0.25C0.585786 0.25 0.25 0.585786 0.25 1V13.96C0.25 14.3742 0.585786 14.71 1 14.71H4.53571V19C4.53571 19.2948 4.70844 19.5623 4.97715 19.6836C5.24586 19.8049 5.56071 19.7575 5.78182 19.5625L11.2835 14.71H21C21.4142 14.71 21.75 14.3742 21.75 13.96V1C21.75 0.585786 21.4142 0.25 21 0.25H1Z"
                    fill="#fff"
                  ></path>
                </svg>
              </span>
            </span>
            メッセージ
            <span
              class="md_numBadge"
              v-if="messageCount.length > 0 && messageCount != '0'"
              >{{ messageCount }}</span
            >
          </a>
        </li>
        <li
          class="menu menu--profile"
          :class="{ active: isProfilePage == '1' }"
        >
          <a
            :href="profileUrl"
            class="btn"
          >
            <span class="iconSet">
              <span class="iconImgPart inactive"
                ><svg
                  width="20"
                  height="20"
                  viewBox="0 0 159 167"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.00765606 122.398C0.0275517 91.9296 26.9757 68.014 59.2088 68.0349C77.0417 68.0464 93.1205 75.3197 104.008 86.9349L96.7127 93.774C87.7451 84.2069 74.3189 78.0446 59.2024 78.0349C31.6057 78.017 10.0234 98.3055 10.0077 122.404C10.0056 125.645 10.3872 128.801 11.1129 131.838L1.38677 134.162C0.480679 130.37 0.00504634 126.432 0.00765606 122.398Z"
                    fill="#fff"
                  ></path>
                  <path
                    d="M80.0007 31.5C80.0007 19.6259 70.3749 10 58.5007 10C46.6266 10 37.0007 19.6259 37.0007 31.5C37.0007 43.3741 46.6266 53 58.5007 53V63C41.1038 63 27.0007 48.897 27.0007 31.5C27.0007 14.103 41.1038 0 58.5007 0C75.8977 0 90.0007 14.103 90.0007 31.5C90.0007 48.897 75.8977 63 58.5007 63V53C70.3749 53 80.0007 43.3741 80.0007 31.5Z"
                    fill="#fff"
                  ></path>
                  <path
                    d="M121.524 78.9998C125.429 75.0945 131.761 75.0945 135.666 78.9998L151.37 94.7039C155.275 98.6092 155.275 104.941 151.37 108.846L107.16 153.056L67 162L75.5914 124.932L121.524 78.9998ZM144.299 101.775L128.595 86.0708L82.6625 132.003L80.5 148.5L100.089 145.985L144.299 101.775Z"
                    fill="#fff"
                  ></path>
                  <path
                    d="M138.214 114.075L131.001 121L107.001 96L114.215 89.0747L138.214 114.075Z"
                    fill="#fff"
                  ></path>
                </svg>
              </span>
              <span class="iconImgPart active"
                ><svg
                  width="20"
                  height="20"
                  viewBox="0 0 159 167"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.00765606 122.398C0.0275517 91.9296 26.9757 68.014 59.2088 68.0349C77.0417 68.0464 93.1205 75.3197 104.008 86.9349L96.7127 93.774C87.7451 84.2069 74.3189 78.0446 59.2024 78.0349C31.6057 78.017 10.0234 98.3055 10.0077 122.404C10.0056 125.645 10.3872 128.801 11.1129 131.838L1.38677 134.162C0.480679 130.37 0.00504634 126.432 0.00765606 122.398Z"
                    fill="#fff"
                  ></path>
                  <path
                    d="M80.0007 31.5C80.0007 19.6259 70.3749 10 58.5007 10C46.6266 10 37.0007 19.6259 37.0007 31.5C37.0007 43.3741 46.6266 53 58.5007 53V63C41.1038 63 27.0007 48.897 27.0007 31.5C27.0007 14.103 41.1038 0 58.5007 0C75.8977 0 90.0007 14.103 90.0007 31.5C90.0007 48.897 75.8977 63 58.5007 63V53C70.3749 53 80.0007 43.3741 80.0007 31.5Z"
                    fill="#fff"
                  ></path>
                  <path
                    d="M121.524 78.9998C125.429 75.0945 131.761 75.0945 135.666 78.9998L151.37 94.7039C155.275 98.6092 155.275 104.941 151.37 108.846L107.16 153.056L67 162L75.5914 124.932L121.524 78.9998ZM144.299 101.775L128.595 86.0708L82.6625 132.003L80.5 148.5L100.089 145.985L144.299 101.775Z"
                    fill="#fff"
                  ></path>
                  <path
                    d="M138.214 114.075L131.001 121L107.001 96L114.215 89.0747L138.214 114.075Z"
                    fill="#fff"
                  ></path>
                </svg>
              </span>
            </span>
            プロフ編集
          </a>
        </li>
      </ul>
    </nav>
    <div class="actionSet">
      <a
        :href="profileUrl"
        class="profile"
        ><span class="iconImgPart"
          ><svg
            width="11"
            height="12"
            viewBox="0 0 11 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.06335 1.0028C3.90052 1.0028 2.95785 1.94546 2.95785 3.1083C2.95785 4.27113 3.90052 5.21379 5.06335 5.21379C6.22618 5.21379 7.16885 4.27113 7.16885 3.1083C7.16885 1.94546 6.22618 1.0028 5.06335 1.0028ZM1.95505 3.1083C1.95505 1.39163 3.34668 0 5.06335 0C6.78001 0 8.17165 1.39163 8.17165 3.1083C8.17165 4.10566 7.7019 4.99332 6.97158 5.56208C7.58421 5.79391 8.14899 6.13774 8.62943 6.58123C9.58537 7.46363 10.1269 8.69236 10.1269 9.95245C10.1269 10.1779 9.82075 10.4215 9.77333 10.452C8.65793 11.1691 7.19028 11.7006 5.06361 11.7006C2.93709 11.7006 1.46951 11.1791 0.354136 10.462C0.207242 10.3675 0 10.1781 0 9.95245C0 8.69236 0.54157 7.46363 1.49751 6.58123C1.97791 6.13778 2.54263 5.79397 3.1552 5.56214C2.42483 4.99338 1.95505 4.1057 1.95505 3.1083ZM1.01305 9.68848C1.95927 10.268 3.21455 10.7206 5.06361 10.7206C6.91249 10.7206 8.16771 10.268 9.11389 9.68864C9.04545 8.80664 8.6361 7.9521 7.94925 7.31809C7.19024 6.61746 6.1528 6.21764 5.06347 6.21764C3.97414 6.21764 2.9367 6.61746 2.17769 7.31809C1.49088 7.95206 1.08154 8.80653 1.01305 9.68848Z"
              fill="white"
            ></path>
          </svg> </span
        ><span class="userName">{{ studentFullName }}</span></a
      >
      <button
        type="button"
        class="menu js_drawerOpen"
        data-drawer="drawer_menuLogin"
        @click="openMenu()"
      >
        <span class="line"></span>
        <span class="line"></span>
        <span class="line"></span>
      </button>
    </div>
    <div
      class="md_drawer md_drawer--menu drawer_menuLogin"
      :class="{ show: isShowMenu }"
    >
      <a
        href="#"
        class="bgLayer js_drawerX"
        @click="closeMenu()"
        :style="{ display: isShowMenu ? 'block' : 'none' }"
      >
        <span class="iconImgPart">
          <svg
            width="8"
            height="8"
            viewBox="0 0 8 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0.646447 0.646447C0.841709 0.451184 1.15829 0.451184 1.35355 0.646447L4 3.29289L6.64645 0.646447C6.84171 0.451184 7.15829 0.451184 7.35355 0.646447C7.54882 0.841709 7.54882 1.15829 7.35355 1.35355L4.70711 4L7.35355 6.64645C7.54882 6.84171 7.54882 7.15829 7.35355 7.35355C7.15829 7.54882 6.84171 7.54882 6.64645 7.35355L4 4.70711L1.35355 7.35355C1.15829 7.54882 0.841709 7.54882 0.646447 7.35355C0.451184 7.15829 0.451184 6.84171 0.646447 6.64645L3.29289 4L0.646447 1.35355C0.451184 1.15829 0.451184 0.841709 0.646447 0.646447Z"
              fill="#fff"
            ></path>
          </svg>
        </span>
      </a>
      <div class="drawerSet">
        <div class="Content">
          <div class="userInfo">
            <a
              :href="profileUrl"
              class="link"
            >
              <div class="nameArea">
                <div class="iconCell">
                  <div class="icon">
                    <img
                      :src="studentLogoImage"
                      alt=""
                    />
                  </div>
                </div>
                <div class="nameCell">
                  <div class="name">{{ studentFullName }}</div>
                  <div class="id">
                    <span class="label">ID</span><span class="num">{{ studentId }}</span>
                  </div>
                </div>
                <div class="arrow">
                  <span class="iconImgPart">
                    <svg
                      width="7"
                      height="12"
                      viewBox="0 0 7 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M0.646447 11.3536C0.451184 11.1583 0.451184 10.8417 0.646447 10.6464L5.29289 6L0.646446 1.35355C0.451184 1.15829 0.451184 0.841709 0.646446 0.646447C0.841708 0.451184 1.15829 0.451184 1.35355 0.646447L6.35355 5.64645C6.54882 5.84171 6.54882 6.15829 6.35355 6.35355L1.35355 11.3536C1.15829 11.5488 0.841709 11.5488 0.646447 11.3536Z"
                        fill="black"
                      ></path>
                    </svg>
                  </span>
                </div>
              </div>
              <div class="progressArea">
                <div class="label">
                  プロフィール完成度<span class="rate"
                    ><span class="num">{{ profileFilledRate }}</span
                    >%</span
                  >
                </div>
                <div class="progressBar">
                  <progress
                    max="100"
                    :value="profileFilledRate"
                  ></progress>
                  <span class="scale_80"></span><span class="scale_100"></span>
                </div>
              </div>
            </a>
          </div>
          <ul class="md_list md_list--menu">
            <li class="row">
              <a
                href="javascript:void(0)"
                class="list"
                @click="transition()"
                ><span class="txtCell">性格・価値観分析</span>
                <span class="arrowCell">
                  <span class="iconImgPart">
                    <svg
                      width="7"
                      height="12"
                      viewBox="0 0 7 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M0.646447 11.3536C0.451184 11.1583 0.451184 10.8417 0.646447 10.6464L5.29289 6L0.646446 1.35355C0.451184 1.15829 0.451184 0.841709 0.646446 0.646447C0.841708 0.451184 1.15829 0.451184 1.35355 0.646447L6.35355 5.64645C6.54882 5.84171 6.54882 6.15829 6.35355 6.35355L1.35355 11.3536C1.15829 11.5488 0.841709 11.5488 0.646447 11.3536Z"
                        fill="black"
                      ></path>
                    </svg>
                  </span>
                </span>
              </a>
            </li>
            <li class="row">
              <a
                :href="profileDiagnosisUrl"
                class="list"
                ><span class="txtCell">プロフィール診断</span>
                <span class="arrowCell">
                  <span class="iconImgPart">
                    <svg
                      width="7"
                      height="12"
                      viewBox="0 0 7 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M0.646447 11.3536C0.451184 11.1583 0.451184 10.8417 0.646447 10.6464L5.29289 6L0.646446 1.35355C0.451184 1.15829 0.451184 0.841709 0.646446 0.646447C0.841708 0.451184 1.15829 0.451184 1.35355 0.646447L6.35355 5.64645C6.54882 5.84171 6.54882 6.15829 6.35355 6.35355L1.35355 11.3536C1.15829 11.5488 0.841709 11.5488 0.646447 11.3536Z"
                        fill="black"
                      ></path>
                    </svg>
                  </span>
                </span>
              </a>
            </li>
            <li class="row">
              <a
                :href="settingUrl"
                class="list"
                ><span class="txtCell">設定</span>
                <span class="arrowCell">
                  <span class="iconImgPart">
                    <svg
                      width="7"
                      height="12"
                      viewBox="0 0 7 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M0.646447 11.3536C0.451184 11.1583 0.451184 10.8417 0.646447 10.6464L5.29289 6L0.646446 1.35355C0.451184 1.15829 0.451184 0.841709 0.646446 0.646447C0.841708 0.451184 1.15829 0.451184 1.35355 0.646447L6.35355 5.64645C6.54882 5.84171 6.54882 6.15829 6.35355 6.35355L1.35355 11.3536C1.15829 11.5488 0.841709 11.5488 0.646447 11.3536Z"
                        fill="black"
                      ></path>
                    </svg>
                  </span>
                </span>
              </a>
            </li>
            <li class="row">
              <a
                :href="contactUrl"
                class="list"
                ><span class="txtCell">お問い合わせ</span>
                <span class="arrowCell">
                  <span class="iconImgPart">
                    <svg
                      width="7"
                      height="12"
                      viewBox="0 0 7 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M0.646447 11.3536C0.451184 11.1583 0.451184 10.8417 0.646447 10.6464L5.29289 6L0.646446 1.35355C0.451184 1.15829 0.451184 0.841709 0.646446 0.646447C0.841708 0.451184 1.15829 0.451184 1.35355 0.646447L6.35355 5.64645C6.54882 5.84171 6.54882 6.15829 6.35355 6.35355L1.35355 11.3536C1.15829 11.5488 0.841709 11.5488 0.646447 11.3536Z"
                        fill="black"
                      ></path>
                    </svg>
                  </span>
                </span>
              </a>
            </li>
            <li class="row">
              <a
                :href="route('student.logout')"
                class="list"
                ><span class="txtCell">ログアウト</span>
                <span class="arrowCell">
                  <span class="iconImgPart">
                    <svg
                      width="7"
                      height="12"
                      viewBox="0 0 7 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M0.646447 11.3536C0.451184 11.1583 0.451184 10.8417 0.646447 10.6464L5.29289 6L0.646446 1.35355C0.451184 1.15829 0.451184 0.841709 0.646446 0.646447C0.841708 0.451184 1.15829 0.451184 1.35355 0.646447L6.35355 5.64645C6.54882 5.84171 6.54882 6.15829 6.35355 6.35355L1.35355 11.3536C1.15829 11.5488 0.841709 11.5488 0.646447 11.3536Z"
                        fill="black"
                      ></path>
                    </svg>
                  </span>
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </header>
  <nav
    class="md_fixBar md_fixBar--menu pcHide"
    id="spNavMenu"
    v-show="!isDisableMobileFooter"
  >
    <ul class="menuList">
      <li
        class="menu menu--scout"
        :class="{ active: isScoutPage == '1' }"
      >
        <a
          :href="scoutUrl"
          class="btn"
        >
          <span class="iconSet"
            ><span class="iconImgPart inactive"
              ><svg
                width="22"
                height="16"
                viewBox="0 0 22 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.3333 0H2C0.895333 0.000666667 0.000666667 0.896 0 2V14C0.00133333 15.1047 0.896 15.9993 2 16H19.3327C20.4373 15.9987 21.332 15.104 21.3327 14V2C21.3313 0.896 20.4373 0.00133333 19.3333 0ZM19.3333 1.33333C19.4253 1.33333 19.5133 1.35267 19.5933 1.38667L19.5893 1.38533L10.6667 9.12L1.74467 1.38533C1.82 1.35267 1.908 1.334 2 1.334L19.3333 1.33333ZM19.3333 14.6667H2C1.63133 14.6667 1.33267 14.368 1.33267 13.9993V2.794L10.2293 10.5047C10.346 10.606 10.4993 10.668 10.6673 10.668C10.8353 10.668 10.9887 10.606 11.106 10.504L11.1053 10.5047L20.002 2.794V13.9993C20.002 14.368 19.7033 14.6667 19.3347 14.6667H19.3333Z"
                  fill="#747C92"
                ></path>
              </svg>
            </span>
            <span class="iconImgPart active"
              ><svg
                width="22"
                height="16"
                viewBox="0 0 22 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0 14C0.00133333 15.1047 0.896 15.9993 2 16H19.3327C20.4373 15.9987 21.332 15.104 21.3327 14V2C21.3326 1.93853 21.3298 1.87771 21.3243 1.81765L10.6567 11.2699L0.0307661 1.64974C0.0106166 1.76347 7.2154e-05 1.88051 0 2V14ZM10.6693 8.91363L20.3884 0.301791C20.1961 0.181893 19.9819 0.0937307 19.7532 0.044626C19.6178 0.0155557 19.4774 0.000173966 19.3333 0H2C1.81157 0.000113719 1.62925 0.0262596 1.45643 0.0750328C1.32293 0.112709 1.19511 0.163887 1.07452 0.226998L10.6693 8.91363Z"
                  fill="#3E5CE2"
                ></path>
              </svg>
            </span>
          </span>
          スカウト</a
        >
        <span
          class="md_numBadge"
          v-if="scoutCount.length > 0 && scoutCount != '0'"
          >{{ scoutCount }}</span
        >
      </li>
      <li
        class="menu menu--companyList"
        :class="{ active: isCompanyPage == '1' }"
      >
        <a
          :href="companyListUrl"
          class="btn"
        >
          <span class="iconSet"
            ><span class="iconImgPart inactive"
              ><svg
                width="19"
                height="20"
                viewBox="0 0 19 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0.399902 1.00039C0.399902 0.66902 0.668532 0.400391 0.999902 0.400391H17.7553C18.0867 0.400391 18.3553 0.66902 18.3553 1.00039V19.0004C18.3553 19.3318 18.0867 19.6004 17.7553 19.6004H12.4154C12.084 19.6004 11.8154 19.3318 11.8154 19.0004V15.554H6.93979V19.0004C6.93979 19.3318 6.67116 19.6004 6.33979 19.6004H0.999902C0.668532 19.6004 0.399902 19.3318 0.399902 19.0004V1.00039ZM1.5999 1.60039V18.4004H5.73979V14.954C5.73979 14.6226 6.00842 14.354 6.33979 14.354H12.4154C12.7468 14.354 13.0154 14.6226 13.0154 14.954V18.4004H17.1553V1.60039H1.5999ZM5.01172 5.70547C5.01172 5.3741 5.28035 5.10547 5.61172 5.10547H7.6167C7.94807 5.10547 8.2167 5.3741 8.2167 5.70547C8.2167 6.03684 7.94807 6.30547 7.6167 6.30547H5.61172C5.28035 6.30547 5.01172 6.03684 5.01172 5.70547ZM11.141 5.10547C10.8096 5.10547 10.541 5.3741 10.541 5.70547C10.541 6.03684 10.8096 6.30547 11.141 6.30547H13.145C13.4764 6.30547 13.745 6.03684 13.745 5.70547C13.745 5.3741 13.4764 5.10547 13.145 5.10547H11.141ZM5.01172 10.0219C5.01172 9.6905 5.28035 9.42188 5.61172 9.42188H7.6167C7.94807 9.42188 8.2167 9.6905 8.2167 10.0219C8.2167 10.3532 7.94807 10.6219 7.6167 10.6219H5.61172C5.28035 10.6219 5.01172 10.3532 5.01172 10.0219ZM11.141 9.42188C10.8096 9.42188 10.541 9.6905 10.541 10.0219C10.541 10.3532 10.8096 10.6219 11.141 10.6219H13.145C13.4764 10.6219 13.745 10.3532 13.745 10.0219C13.745 9.6905 13.4764 9.42188 13.145 9.42188H11.141Z"
                  fill="#747C92"
                ></path>
              </svg>
            </span>
            <span class="iconImgPart active"
              ><svg
                width="19"
                height="20"
                viewBox="0 0 19 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M1 0.25C0.585786 0.25 0.25 0.585786 0.25 1V19C0.25 19.4142 0.585786 19.75 1 19.75H6.33988C6.7541 19.75 7.08988 19.4142 7.08988 19V15.7036H11.6655V19C11.6655 19.4142 12.0013 19.75 12.4155 19.75H17.7554C18.1696 19.75 18.5054 19.4142 18.5054 19V1C18.5054 0.585786 18.1696 0.25 17.7554 0.25H1ZM4.91182 5.70508C4.91182 5.31848 5.22522 5.00508 5.61182 5.00508H7.6168C8.0034 5.00508 8.3168 5.31848 8.3168 5.70508C8.3168 6.09168 8.0034 6.40508 7.6168 6.40508H5.61182C5.22522 6.40508 4.91182 6.09168 4.91182 5.70508ZM10.4411 5.70505C10.4411 5.31845 10.7545 5.00505 11.1411 5.00505H13.1451C13.5317 5.00505 13.8451 5.31845 13.8451 5.70505C13.8451 6.09165 13.5317 6.40505 13.1451 6.40505H11.1411C10.7545 6.40505 10.4411 6.09165 10.4411 5.70505ZM4.91184 10.0213C4.91184 9.63474 5.22524 9.32134 5.61184 9.32134H7.61683C8.00343 9.32134 8.31683 9.63474 8.31683 10.0213C8.31683 10.4079 8.00343 10.7213 7.61683 10.7213H5.61184C5.22524 10.7213 4.91184 10.4079 4.91184 10.0213ZM10.4411 10.0213C10.4411 9.63474 10.7545 9.32134 11.1411 9.32134H13.1451C13.5317 9.32134 13.8451 9.63474 13.8451 10.0213C13.8451 10.4079 13.5317 10.7213 13.1451 10.7213H11.1411C10.7545 10.7213 10.4411 10.4079 10.4411 10.0213Z"
                  fill="#3E5CE2"
                ></path>
              </svg>
            </span> </span
          >企業リスト</a
        >
      </li>
      <li
        class="menu menu--message"
        :class="{ active: isMessagePage == '1' }"
      >
        <a
          :href="messageUrl"
          class="btn"
        >
          <span class="iconSet"
            ><span class="iconImgPart inactive"
              ><svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0.399902 1.00039C0.399902 0.66902 0.668532 0.400391 0.999902 0.400391H20.9999C21.3313 0.400391 21.5999 0.66902 21.5999 1.00039V13.9604C21.5999 14.2918 21.3313 14.5604 20.9999 14.5604H11.2267L5.6825 19.4504C5.50562 19.6064 5.25374 19.6443 5.03877 19.5473C4.8238 19.4502 4.68562 19.2362 4.68562 19.0004V14.5604H0.999902C0.668532 14.5604 0.399902 14.2918 0.399902 13.9604V1.00039ZM1.5999 1.60039V13.3604H5.28562C5.61699 13.3604 5.88562 13.629 5.88562 13.9604V17.6712L10.603 13.5104C10.7126 13.4137 10.8538 13.3604 10.9999 13.3604H20.3999V1.60039H1.5999Z"
                  fill="#747C92"
                ></path>
              </svg>
            </span>
            <span class="iconImgPart active"
              ><svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M1 0.25C0.585786 0.25 0.25 0.585786 0.25 1V13.96C0.25 14.3742 0.585786 14.71 1 14.71H4.53571V19C4.53571 19.2948 4.70844 19.5623 4.97715 19.6836C5.24586 19.8049 5.56071 19.7575 5.78182 19.5625L11.2835 14.71H21C21.4142 14.71 21.75 14.3742 21.75 13.96V1C21.75 0.585786 21.4142 0.25 21 0.25H1Z"
                  fill="#3E5CE2"
                ></path>
              </svg>
            </span> </span
          >メッセージ</a
        ><span
          class="md_numBadge"
          v-if="messageCount.length > 0 && messageCount != '0'"
          >{{ messageCount }}</span
        >
      </li>
      <li
        class="menu menu--profile"
        :class="{ active: isProfilePage == '1' }"
      >
        <a
          :href="profileUrl"
          class="btn"
        >
          <span class="iconSet"
            ><span class="iconImgPart inactive"
              ><svg
                width="20"
                height="20"
                viewBox="0 0 159 167"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.00765606 122.398C0.0275517 91.9296 26.9757 68.014 59.2088 68.0349C77.0417 68.0464 93.1205 75.3197 104.008 86.9349L96.7127 93.774C87.7451 84.2069 74.3189 78.0446 59.2024 78.0349C31.6057 78.017 10.0234 98.3055 10.0077 122.404C10.0056 125.645 10.3872 128.801 11.1129 131.838L1.38677 134.162C0.480679 130.37 0.00504634 126.432 0.00765606 122.398Z"
                  fill="#747C92"
                ></path>
                <path
                  d="M80.0007 31.5C80.0007 19.6259 70.3749 10 58.5007 10C46.6266 10 37.0007 19.6259 37.0007 31.5C37.0007 43.3741 46.6266 53 58.5007 53V63C41.1038 63 27.0007 48.897 27.0007 31.5C27.0007 14.103 41.1038 0 58.5007 0C75.8977 0 90.0007 14.103 90.0007 31.5C90.0007 48.897 75.8977 63 58.5007 63V53C70.3749 53 80.0007 43.3741 80.0007 31.5Z"
                  fill="#747C92"
                ></path>
                <path
                  d="M121.524 78.9998C125.429 75.0945 131.761 75.0945 135.666 78.9998L151.37 94.7039C155.275 98.6092 155.275 104.941 151.37 108.846L107.16 153.056L67 162L75.5914 124.932L121.524 78.9998ZM144.299 101.775L128.595 86.0708L82.6625 132.003L80.5 148.5L100.089 145.985L144.299 101.775Z"
                  fill="#747C92"
                ></path>
                <path
                  d="M138.214 114.075L131.001 121L107.001 96L114.215 89.0747L138.214 114.075Z"
                  fill="#747C92"
                ></path>
              </svg>
            </span>
            <span class="iconImgPart active"
              ><svg
                width="20"
                height="20"
                viewBox="0 0 159 167"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.00765606 122.398C0.0275517 91.9296 26.9757 68.014 59.2088 68.0349C77.0417 68.0464 93.1205 75.3197 104.008 86.9349L96.7127 93.774C87.7451 84.2069 74.3189 78.0446 59.2024 78.0349C31.6057 78.017 10.0234 98.3055 10.0077 122.404C10.0056 125.645 10.3872 128.801 11.1129 131.838L1.38677 134.162C0.480679 130.37 0.00504634 126.432 0.00765606 122.398Z"
                  fill="#3E5CE2"
                ></path>
                <path
                  d="M80.0007 31.5C80.0007 19.6259 70.3749 10 58.5007 10C46.6266 10 37.0007 19.6259 37.0007 31.5C37.0007 43.3741 46.6266 53 58.5007 53V63C41.1038 63 27.0007 48.897 27.0007 31.5C27.0007 14.103 41.1038 0 58.5007 0C75.8977 0 90.0007 14.103 90.0007 31.5C90.0007 48.897 75.8977 63 58.5007 63V53C70.3749 53 80.0007 43.3741 80.0007 31.5Z"
                  fill="#3E5CE2"
                ></path>
                <path
                  d="M121.524 78.9998C125.429 75.0945 131.761 75.0945 135.666 78.9998L151.37 94.7039C155.275 98.6092 155.275 104.941 151.37 108.846L107.16 153.056L67 162L75.5914 124.932L121.524 78.9998ZM144.299 101.775L128.595 86.0708L82.6625 132.003L80.5 148.5L100.089 145.985L144.299 101.775Z"
                  fill="#3E5CE2"
                ></path>
                <path
                  d="M138.214 114.075L131.001 121L107.001 96L114.215 89.0747L138.214 114.075Z"
                  fill="#3E5CE2"
                ></path>
              </svg>
            </span> </span
          >プロフ編集</a
        >
      </li>
    </ul>
  </nav>
  <Teleport to="#modals">
    <ConfirmMoveTalentAnalyticsModal
      :is-display="isDisplayConfirmMoveTalentAnalyticsModal && !isShowTaError"
      :close="closeConfirmMoveTalentAnalyticsModal"
    />
  </Teleport>
</template>
